/// <reference path="pic.common.js" />
import docReady from './Functions/docReady'

docReady(function () {
	document.body.classList.add('page-article');

	// order important!
	PageNavigation.init();
});

var PageNavigation = (function () {
	function generateToc() {
		var toc =
			'<ul>';

		var newLine, title, link;
		var elements = document.getElementById('sectionAbout').getElementsByTagName('h2');

		Array.from(elements).forEach(el => {
			title = el.textContent;
			link = '#' + el.id;

			newLine =
				'<li>' +
					'<a href="' + link + '">' +
						title +
					'</a>' +
				'</li>';

			toc += newLine;
		});

		toc +=
			'</ul>';
		const tocElement = document.getElementById('toc');
		if (!!tocElement) {
			tocElement.innerHTML += toc;
        }
		
	}

	function init() {
		generateToc();
	}

	return {
		init: init
	};
}());

/// <reference path="pic.common.js" />
